import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Fire-and-forget page view tracker. Silent on failure.
export const trackPageView = (page) => {
  try {
    axios.post(
      `${API}/track/page-view`,
      {
        page,
        path: typeof window !== 'undefined' ? window.location.pathname : '',
        referrer: typeof document !== 'undefined' ? document.referrer : ''
      },
      { timeout: 5000 }
    ).catch(() => {});
  } catch (_e) {
    /* noop */
  }
};

// Fire-and-forget engineer card click tracker.
export const trackEngineerClick = (engineerId, source = 'find') => {
  if (!engineerId) return;
  try {
    axios.post(
      `${API}/track/engineer-click`,
      { engineerId, source },
      { timeout: 5000 }
    ).catch(() => {});
  } catch (_e) {
    /* noop */
  }
};
